<template>
  <div class="box">
    <div class="box-header">
      <h3>Job Type</h3>
    </div>
    <div class="box-body">
      <ul>
        <li :class="{ active: form.isBasic }" @click="form.isBasic = !form.isBasic">Basic Job</li>
        <li :class="{ active: form.jopmai }" @click="form.jopmai = !form.jopmai">JopMai Job</li>
        <li :class="{ active: form.disabledPeople }" @click="form.disabledPeople = !form.disabledPeople">disabled People
        </li>
      </ul>
      <p style="color:red" v-if="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info", "error"],
  data: () => ({
    form: {
      isBasic: true,
      jopmai: false,
      disabledPeople: false
    },
  }),
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.$emit('input', val)
        }
      },
      immediate: true,
      deep: true
    },
    "info": {
      handler(val) {
        if (val) {
          this.form.isBasic = val.isBasic
          this.form.jopmai = val.jopmai
          this.form.disabledPeople = val.disabledPeople ? val.disabledPeople : false
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  li {
    margin: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: var(--light-grey-color);
    padding: 0 20px;
    height: 2.5rem;
    border-radius: var(--radius);
    font-size: var(--sm-font);

    &.active {
      background-color: rgba(var(--primary-color-rgb), 0.09);
      color: var(--primary-color) !important;
      border: 2px solid var(--primary-color);
    }
  }
}
</style>
